import React, { ComponentProps } from 'react';
import { Label } from 'src/components/atomsLegacy';
import styled from 'styled-components';

export type TimePickerProps = ComponentProps<typeof Time> & {
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const TimePicker = ({ label, ...props }: TimePickerProps) => {
  return (
    <Container>
      <Label htmlFor={props.id}>{label}</Label>
      <Time type="time" {...props} />
    </Container>
  );
};

const Container = styled.div`
  margin-top: 16px;
`;

const Time = styled.input`
  margin-top: 16px;
  width: 100%;
  border: solid 1px
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  padding: 5px 8px;
  cursor: pointer;
`;
